import { useQuery } from "react-query";
import { AdoMetricResult, fetchBugSeveritySplit } from "../api/aiMetricsApi";
import { ADO_QUERY_KEYS, adoPriorQueryKey } from "./adoQueryKeys";

interface IUseAdoBugSeveritySplitOptions {
  isProjectWideQuality?: boolean;
}

export const useAdoBugSeveritySplit = (
  teams: string[],
  startDate: Date,
  endDate: Date,
  priorStartDate: Date,
  priorEndDate: Date,
  comparisonEnabled = true,
  sprints: string[] = [],
  { isProjectWideQuality = false }: IUseAdoBugSeveritySplitOptions = {},
) => {
  const sprintsKey = JSON.stringify([...sprints].sort());
  const current = useQuery<AdoMetricResult[], Error>(
    [
      ADO_QUERY_KEYS.bugSeveritySplit,
      JSON.stringify([...teams].sort()),
      startDate.toISOString(),
      endDate.toISOString(),
      isProjectWideQuality,
      sprintsKey,
    ],
    () =>
      fetchBugSeveritySplit(
        teams,
        startDate,
        endDate,
        sprints,
        isProjectWideQuality,
      ),
    {
      staleTime: 5 * 60 * 1000,
      enabled: teams.length > 0 || isProjectWideQuality,
    },
  );
  const prior = useQuery<AdoMetricResult[], Error>(
    [
      adoPriorQueryKey(ADO_QUERY_KEYS.bugSeveritySplit),
      JSON.stringify([...teams].sort()),
      priorStartDate.toISOString(),
      priorEndDate.toISOString(),
      isProjectWideQuality,
      sprintsKey,
    ],
    () =>
      fetchBugSeveritySplit(
        teams,
        priorStartDate,
        priorEndDate,
        sprints,
        isProjectWideQuality,
      ),
    {
      staleTime: 5 * 60 * 1000,
      enabled: (teams.length > 0 || isProjectWideQuality) && comparisonEnabled,
    },
  );
  return { current, prior };
};
